// extracted by css-extract-rspack-plugin
export default {"value":"L9Y2p","fk":"XPhjB","imageFrame":"f3lql","maxHeight":"XjJ92","json":"WmGa4"};